"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiError = exports.apiSuccess = exports.apiRequest = exports.API_ERROR = exports.API_SUCCESS = exports.API_REQUEST = void 0;
exports.API_REQUEST = 'API_REQUEST';
exports.API_SUCCESS = 'API_SUCCESS';
exports.API_ERROR = 'API_ERROR';
const apiRequest = ({ body, method, url, feature }) => ({
    type: `${feature} ${exports.API_REQUEST}`,
    payload: body,
    meta: { method, url, feature },
});
exports.apiRequest = apiRequest;
const apiSuccess = ({ response, feature }) => ({
    type: `${feature} ${exports.API_SUCCESS}`,
    payload: response,
    meta: { feature },
});
exports.apiSuccess = apiSuccess;
const apiError = ({ error, feature }) => ({
    type: `${feature} ${exports.API_ERROR}`,
    payload: error,
    meta: { feature },
});
exports.apiError = apiError;
//# sourceMappingURL=api.js.map